














import vue, { CreateElement } from "vue"
import { Component, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex"
import { DefaultProps } from "vue/types/options";
import { Tree } from "element-ui";

export interface UserTree {
    name: string;
    level: string;
    no: string;
    children: UserTree[] | {}[];
    role: string;
}

@Component({
    ...mapGetters(["account"])
})

export default class AllUserTree extends vue {
    treeData: UserTree[] = [{
        name: this.$store.state.account.name,
        level: this.$store.state.account.level,
        no: this.$store.state.account.no,
        children: this.$store.state.account.leaf == 0 ? [{}] : [],
        role: this.$store.state.account.role,
    }];
    defaultProps: DefaultProps = {
        children: "children",
        label: "name"
    }

    @Prop({ type: String, default: "100%" })
    height!: string;

    @Prop({ type: String, default: "0" })
    left!: string;

    @Prop({ type: String, default: "0" })
    top!: string;

    @Prop({ type: String, default: "100%" })
    width!: string;

    @Prop({ type: Boolean, default: false })
    isComponent!: boolean;

    mounted() {
        this.getUsers();
    }

    getUsers(data?: UserTree) {
        if (!data) {
            data = this.treeData[0];
        }
        vue.axios.get("accounts/findmyaccounters?accounterNo=" + data.no).
            then((response) => {
                response.data.forEach((v: Account) => {
                    if (v.leaf == 0) {
                        v.children = [{}];
                    }
                })
                if (data) data.children = response.data;
            })
    }

    // 展开树, 获取数据
    nodeExpand(data: UserTree) {
        this.getUsers(data);
        this.$emit("expand", data);
    }

    // 折叠树,清空数据
    nodeColla(data: UserTree) {
        data.children = [{}]
    }

    // 点击树中的node
    handleNodeClick(data: Account) {
        this.$emit("click-node", data);
    }

    // 渲染树
    // @ts-ignore
    renderEle(h: CreateElement, { node, data, store }) {
        if (data.role == "主管") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "manager", scale: "35.5", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else if (data.role == "管理员") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "general", scale: "35.5", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else if (data.role == "会计") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "accounter", scale: "35.5", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else if (data.role == "助理") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "assistant", scale: "35.5", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else if (data.role == "经理") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "gm", scale: "36", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else if (data.role == "超级管理员") {
            return h("span", {}, [
                h("span", {}, [
                    h("icon", { attrs: { name: "super", scale: "36", style: "vertical-align: -3px" } }),
                    h("span", {}, [" " + node.label])
                ])
            ])
        } else {
            return h("span", {}, [])
        }
    }
}

